import { EqaStringHandler } from '@shared/types/handler';

export const DEFAULT_ICONS_PATH: EqaStringHandler<string> = (name) => (name.includes('.svg#') ? name : `#${name}`);
